var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-10"},[_c('button',{staticClass:"btn btn-primary bg-blue-400 btn-block",attrs:{"disabled":_vm.timerEnabled,"type":"button"},on:{"click":_vm.resendActivation}},[_vm._v(" "+_vm._s(_vm.$t('loginRegister.resendAct'))+" "+_vm._s(_vm.timerEnabled ? `: (${_vm.countDown})` : '')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }